import { createAsyncThunk } from "@reduxjs/toolkit";
import { APIClient } from "../../helpers/api_helper";
import {
    GET_WHATSAPP_CREDITS,
    CREATE_WHATSAPP_CREDIT_ORDER,
    VERIFY_WHATSAPP_CREDITS,
    GET_WHATSAPP_USAGE,
} from "../../helpers/url_helper";

const api = new APIClient();

/** Fetch current WhatsApp credit balance */
export const fetchWhatsAppCredits = createAsyncThunk(
    "whatsapp/fetchCredits",
    async (_, { rejectWithValue }) => {
        try {
            return await api.get(GET_WHATSAPP_CREDITS);
        } catch (err) {
            return rejectWithValue(err?.response?.data?.error || err.message);
        }
    }
);

/**
 * Create a Razorpay order for purchasing credits.
 * @param {number} amount  100 | 500 | 1000 (rupees)
 */
export const createWhatsAppCreditOrder = createAsyncThunk(
    "whatsapp/createCreditOrder",
    async (amount, { rejectWithValue }) => {
        try {
            return await api.create(CREATE_WHATSAPP_CREDIT_ORDER, { amount });
        } catch (err) {
            return rejectWithValue(err?.response?.data?.error || err.message);
        }
    }
);

/**
 * Verify payment signature and top-up wallet.
 * @param {{ razorpayOrderId, razorpayPaymentId, razorpaySignature, amount }} payload
 */
export const verifyAndAddCredits = createAsyncThunk(
    "whatsapp/verifyCredits",
    async (payload, { rejectWithValue }) => {
        try {
            return await api.create(VERIFY_WHATSAPP_CREDITS, payload);
        } catch (err) {
            return rejectWithValue(err?.response?.data?.error || err.message);
        }
    }
);

/** Fetch message usage logs (last 20) */
export const fetchWhatsAppUsage = createAsyncThunk(
    "whatsapp/fetchUsage",
    async (_, { rejectWithValue }) => {
        try {
            return await api.get(GET_WHATSAPP_USAGE);
        } catch (err) {
            return rejectWithValue(err?.response?.data?.error || err.message);
        }
    }
);
